// extracted by mini-css-extract-plugin
module.exports = {"fw":"LoadingIcon_fw__2rjdM","icon":"LoadingIcon_icon__z1zUK"};